import request, { IServerResponse } from '@/utils/request';
import { IAccountRes, IProtocolStatusRes, IDynamicMenuRes, IAnnouncement } from './define';
// 获取账号信息
export const getSignStateList = (): Promise<IServerResponse<IAccountRes>> =>
    request.get('/api/serviceProvider');

// 获取当前账号是否同意过协议信息
export const getProtocolStatus = (): Promise<IServerResponse<IProtocolStatusRes>> =>
    request.get('/api/manageSpecProtocol/status');

// 获取客服登录url
export const getDXLoginUrl = (): Promise<IServerResponse<string>> =>
    request.get('/api/dx/login/url');

// 判断是否交过保证金
export const getMarginAccountStatus = (): Promise<IServerResponse<string>> =>
    request.get('/api/marginAccount/status');

// 获取评价管理未读
export const getEvaliationUnread = (): Promise<IServerResponse<number>> =>
    request.post('/api/evaluate/unreply/count');

// 获取消息中心未读
export const getMessageUnread = (): Promise<IServerResponse<number>> =>
    request.post('/api/message/count');

// 获取动态菜单
export const getDynamicMenu = (): Promise<IServerResponse<IDynamicMenuRes[]>> =>
    request.get('/api/menu/list');

// 获取服务商公告信息
export const getNoticeList = (): Promise<IServerResponse<IAnnouncement[]>> =>
    request.get('/api/message/announcement');

const groupCodeList = process.env.APP_ENV === 'qa' ? 100052637 : 100136112;
const resourcesUrl =
    process.env.APP_ENV === 'stage'
        ? '/api/menu/mock'
        : `/merchant/api/gw/IMenuQueryService/getMenu?groupCodeList=${groupCodeList}&bizLine=12&permissionSpace=33&resourceType=daojia:maiwai_partner_pc_menu&client=PC&terminal=PC`;

// 获取账户权限菜单
export const getResourcesList = (): Promise<IServerResponse<any>> => request.get(resourcesUrl);
